import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzCarouselComponent } from 'ng-zorro-antd/carousel';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { environment } from '../../../../environments/environment';
import { BreadcrumbsComponent } from '../../../components/shared/breadcrumbs/breadcrumbs.component';
import { GenericService } from '../../../services/generic.services';
import { NewsService } from '../../../services/news.service';

@Component({
  selector: 'app-news-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    BreadcrumbsComponent,
    TranslateModule,
    NzSkeletonComponent,
    NzCarouselComponent,
    NzTagModule,
  ],
  templateUrl: './news-old-detail.component.html',
  styleUrl: './news-detail.component.scss',
})
export class NewsDetailComponent {
  @Input() channel: string = '';
  urlIMG = environment.urlIMG;
  loader: boolean = true;
  loaderMoreNews: boolean = true;

  newsView: any;
  newsContent: any;
  newsContentonTop: boolean = false;
  tagsNews: Array<string> = [];
  arraysNotice: Array<any> = [];
  dateNews: any;
  viewsSlice: any = [
    { x: 0, y: 3 },
    { x: 3, y: 6 },
    { x: 6, y: 9 },
  ];

  constructor(
    private readonly newsService: NewsService,
    private meta: Meta,
    private titleService: Title,
    public readonly genericServices: GenericService
  ) {}

  ngOnChanges(): void {
    this.newsContentonTop = false;
    this.loader = true;
    this.loadNewsFeed(this.channel);
    this.loadAllNews();
  }

  loadNewsFeed(channel: string): void {
    this.newsService.getNewsFeed(channel).subscribe(
      (result: any) => {
        if (result.status) {
          if (result.newsSeoText.position === 'Top') {
            this.newsContentonTop = true;
          }
          this.newsContent = result.newsSeoText;
          this.newsView = result.news;
          this.dateNews =
            result.news.match_date &&
            this.genericServices.getDisplayDate(result.news.match_date);
          // moment(result.news.match_date)
          //   .format('MMMM DD, YYYY')
          //   .toString();
          this.tagsNews = result.news.meta_keywords.split(',');
          //Update the Meta Header for this news.
          this.titleService.setTitle(this.newsView.meta_title);
          this.meta.updateTag({
            name: 'description',
            content: this.newsView.meta_description,
          });
          this.meta.updateTag({
            name: 'keywords',
            content: this.newsView.meta_keywords,
          });
          this.meta.updateTag({
            name: 'author',
            content: this.newsView.meta_author || 'Marcadores 24/7',
          });

          setTimeout(() => {
            this.loader = false;
          }, 500);
        } else this.loader = false;
      },
      () => {
        this.loader = false;
      }
    );
  }

  loadAllNews(): void {
    this.newsService.getFeedUpdates().subscribe(
      (result: any) => {
        if (result.status) {
          this.arraysNotice = result.data.slice(0, 9);
          setTimeout(() => {
            this.loaderMoreNews = false;
          }, 500);
        } else this.loaderMoreNews = false;
      },
      () => {
        this.loaderMoreNews = false;
      }
    );
  }
}
